<template>
  <v-container class="terms-of-service">
    <v-layout row>
      <v-flex class="my-5">
        <H1>
          Terms of Service
        </H1>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss">
.terms-of-service {
  display: inherit;
}
</style>

<script>
export default {
  name: 'termsOfService',
  data () {
    return {
    }
  }
}
</script>
